import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';
import { emailValidator } from 'app/helpers/emailValidator';

@Directive({
  selector: '[isEmail]',
  providers: [{ provide: NG_VALIDATORS, useExisting: isEmailDirective, multi: true }]
})
export class isEmailDirective implements Validator {
  @Input('isEmail') emailFields: string[] = [];

    validate(formGroup: FormGroup): ValidationErrors | null {
      for (let index = 0; index < this.emailFields.length; index++) {
        const control = formGroup.controls[this.emailFields[index]];
        if (!control) {continue};
        if(emailValidator(control) != null){
         control.setErrors({ invalidEmail: true });
        }
      }
      return null;
    }
}